__turbopack_context__.v({
  "upgradeModalButton": "UpgradeModalButton-module__g_i6BW__upgradeModalButton",
});
